import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Observable, of } from 'rxjs';
import {
  AuthCredential,
  AuthStorage,
} from 'src/app/client/repositories/lib/auth';
import { environment } from 'src/environments/environment';

@Injectable()
export class AuthGuardService {
  constructor(private router: Router, private authStorage: AuthStorage) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    const credential = this.authStorage.getCredential();

    if (
      credential &&
      localStorage.getItem('confirmed') === 'true' &&
      this.isValidCredential(credential)
    ) {
      return of(true);
    }

    this.navigateToLandingPage();
    return of(false);
  }
  canActivateChild(
    childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | boolean
    | UrlTree
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree> {
    // this.navigateToLandingpage();
    return of(true);
  }

  tokenExpired(token?: string): boolean {
    if (!token) {
      return true;
    }

    try {
      const payload = token.split('.')[1];

      if (!payload) {
        return true;
      }

      const expiry = JSON.parse(atob(payload)).exp;
      return Math.floor(new Date().getTime() / 1000) >= expiry;
    } catch {
      return true;
    }
  }

  private isValidCredential(credential: AuthCredential): boolean {
    if (!environment.isSecure && credential.localAuth) {
      return true;
    }

    return !this.tokenExpired(credential.idToken);
  }

  private navigateToLandingPage(): void {
    this.router.navigate(['/pages']);
  }
}
